export default "__VITE_ASSET__COiaXjtp__"